@if ((files?.length ?? 0) > 1) {
<button class="btn btn-secondary" (click)="download()">
    <fa-icon [icon]="faDownload" aria-hidden="true"></fa-icon>
    &nbsp;
    <ng-container i18n>Download as ZIP-file</ng-container>
</button>
}
@for (file of files; track file) {
<ell-file-icon [allowDelete]="allowDelete" [file]="file" (download)="download(file)" (delete)="delete(file)"></ell-file-icon>
}
@if (!readonly) {
<ell-file-dropzone (addFiles)="addFiles.next($event)" />
}
